
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {
    "buildId": "eb425f00-6e75-4ccb-b43f-2ed6440c8557"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "/builds/projectowners/lawofficesystem/app.config.ts"

export default /* #__PURE__ */ defuFn(cfg0, inlineConfig)
